export const odluka_ovlast_ZNR = {
    templateId: 102,
    category: 10,
    templateTitle: 'Odluka o imenovanju ovlaštenika poslodavca za ZNR',
    templateDescription: `<p> Poslodavac može provođenje zaštite na radu prenijeti u pisanom obliku na svojeg ovlaštenika u okviru njegovog djelokruga rada.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Poslodavac je odgovoran za organiziranje i provođenje zaštite na radu radnika u svim dijelovima organizacije rada i u svim radnim postupcima.</p>
    <p>Poslodavac može provođenje zaštite na radu prenijeti u pisanom obliku na svojeg ovlaštenika, u okviru njegovog djelokruga rada.</p>
    <p>Ovlaštenik je radnik kojemu je poslodavac, neovisno o drugim ugovorenim poslovima, dao ovlaštenja za provedbu zaštite na radu.</p>
    <p>Poslodavac koji zaštitu na radu provodi djelovanjem ovlaštenika obvezan je ovlastiti ovlaštenika na način određen Zakonom o zaštiti na radu.</p>
   
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o zaštiti na radu.</p>
  `,
    sides: [
        {
            prefix: 'Na temelju Zakona o zaštiti na radu,',
            signature: 'Za Poslodavca',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Poslodavac),',
        }
    ],

    headline: '​donosi sljedeću',
    title: 'ODLUKU O IMENOVANJU OVLAŠTENIKA ZAŠTITE NA RADU',
    noArticleNumbers: true,

    articles: [
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Ovom Odlukom, sukladno Zakonu o zaštiti na radu, Poslodavac imenuje ovlaštenika zaštite na kojega prenosi provođenje poslova zaštite na radu.',
                    value: '',
                },
            ],
            value: '',
        },
        {
            title: '',
            mandatory: true,
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                    { type: 'text', content: 'Radnik' },
                    { type: 'input', value: '', required: true, placeholder: "Ime i prezime", },
                    { type: "text", content: "," },
                    { type: 'text', content: 'iz' },
                    { type: 'input', value: '', required: true,placeholder: "Mjesto", },
                    { type: 'text', content: ',' },
                    { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj", },
                    { type: "text", content: "," },
                    { type: 'text', content: 'OIB:' },
                    { type: "input",  required: true,},
                    { type: 'text', content: 'zaposlen na radnom mjestu' },
                    { type: "input",  required: true,},
                    { type: 'text', content: '(u daljnjem tekstu: Ovlaštenik),'},
                    { type: 'text', content: 'imenuje se ovlaštenikom Poslodavca za zaštitu na radu.' },
                ]
              }
            ]
          },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Ovlaštenik ima sljedeća prava i obveze: \r\n- zabraniti rad radniku koji nije osposobljen za rad na siguran način, \r\n- odrediti da radnik koji nije osposobljen za rad na siguran način da ne smije obavljati poslove s posebnim uvjetima rada, odnosno da radniku koji više ne ispunjava tražene uvjete zabrani da nastavi obavljati poslove s posebnim uvjetima rada, \r\n- posebno osjetljivim skupinama radnika ne dozvoliti obavljanje poslova koji bi mogli na njih štetno utjecati,  \r\n- isključiti iz uporabe radnu opremu koja nije ispravna, odnosno sigurna, kao i osobnu zaštitnu opremu na kojoj nastanu promjene zbog kojih postoje rizici za sigurnost i zdravlje radnika,  \r\n- u suradnji sa stručnjakom za zaštitu na radu osigurati evidentiranje svake nezgode i ozljede na radu te svakog slučaja postupanja radnika pri kojemu radnik izvijesti ovlaštenika o riziku za sigurnost za zdravlje ili nedostatak u sustavu zaštite na radu, kao i u slučajevima kad radnik odbije raditi i napustiti radno mjesto ako izravni prijeti rizik za život i zdravlje,  \r\n- nadzirati da radnici rade u skladu s pravilima zaštite na radu, uputama poslodavca, odnosno proizvođača radne opreme, osobne zaštitne opreme, opasnih kemikalija i bioloških štetnosti te da koriste propisanu osobnu zaštitnu opremu,  \r\n- radniku zabraniti rad ukoliko postoji neposredni ili izravni rizik za sigurnost i zdravlje radnika ili nedostatku sustava zaštite na radu, \r\n- osigurati potreban broj radnika osposobljenih za evakuaciju i spašavanje, za pružanje prve pomoći te im staviti na raspolaganje svu potrebnu opremu,  \r\n- osigurati da se u vrijeme rada ne piju alkoholna pića te da se ne uzimaju druga sredstva ovisnosti, odnosno da zabrani rad radnicima koji su na radu pod utjecajem alkohola ili drugih sredstava ovisnosti i da ih udalji s mjesta rada.',
                    value: '',
                },
            ],
            value: '',
        }, 
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Poslodavac će Ovlašteniku osigurati uvjete za rad te ga neće staviti u nepovoljniji položaj zbog poduzimanja aktivnosti u skladu s pravilima zaštite na radu te postupanja po pravilima struke i danim ovlaštenjima Poslodavca.',
                    value: '',
                },
            ],
            value: '',
        },   
      
          {
            title: "",
            mandatory: true,
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                    { type: "text", content: "Ova Odluka se primjenjuje od dana" }, 
                    { type: "input", value: "", required: true },
                    { type: "text", content: "godine, sve do opoziva."}, 
                ],
              }
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        {
                            type: 'text',
                            content: 'U'
                        },
                        {
                            type: 'input',
                            value: '',
                            placeholder: "Upišite mjesto.",
                            required: true
                        },
                        {
                            type: 'text',
                            content: ', dana'
                        },
                        {
                            type: 'date',
                            value: new Date(),
                            required: true
                        },
                        {
                            type: 'text',
                            content: 'godine.',
                        }
                    ]
                },
            ]
        },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
        {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Dostaviti:\r\n1) Ovlašteniku \r\n2) Arhiva',
                    help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
                }
            ]
        },
    ],
};





// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/102_odluka_ovlast_ZNR.ts